import { BreakoutTextInput } from 'components/design-system/BreakoutTextInput'
import { useTranslationTyped } from 'i18n/i18n'
import type { UseFormReturn } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import type { FormValues } from './schema'

export function EstimatedFields({
  control,
  onChange,
  requireProductSelection,
}: {
  control: UseFormReturn<FormValues>['control']
  onChange: () => void
  requireProductSelection: boolean
}) {
  const { tt } = useTranslationTyped()
  return (
    <>
      <Controller
        control={control}
        name="estimatedNumberOfUsers"
        render={({ field, fieldState }) => {
          return (
            <BreakoutTextInput
              label={tt.lti.configuration.invoicing_estimated_number_of_users()}
              labelClass="mb-2"
              {...field}
              onChange={(e) => {
                field.onChange(e)
                onChange()
              }}
              type="number"
              error={fieldState.error}
            />
          )
        }}
      />

      <Controller
        control={control}
        name="estimatedNumberOfExperiences"
        render={({ field, fieldState }) => {
          if (requireProductSelection) {
            return <input type="hidden" {...field} />
          }
          return (
            <BreakoutTextInput
              label={tt.lti.configuration.invoicing_estimated_number_of_experiences()}
              {...field}
              labelClass="mb-2"
              onChange={(e) => {
                field.onChange(e)
                onChange()
              }}
              type="number"
              error={fieldState.error}
            />
          )
        }}
      />
    </>
  )
}
